export default "__VITE_ASSET__cf4159d8__"